<template>
  <AdminCandidate>
    <div class="row">
      <div class="col-lg-12 col-xs-12">
        <div class="card">
          <div class="card-body">
            <div class="calibre" id="calibre_link-0">
              <p class="block_">TERMOS E CONDIÇÕES DE USO DA PLATAFORMA JOVOOL</p>
              <p class="block_1">&nbsp;</p>
              <p class="block_2">
                A Jovool
                <span
                  class="calibre1"
                >presta serviços relacionados à recrutamento e seleção por meio de sua Plataforma de recrutamento com entrevistas por vídeo.</span>
              </p>
              <p
                class="block_2"
              >Por meio de seu site, a Jovool oferece aos seus clientes ferramentas e soluções para o controle e organização de processos seletivos, divulgação de anúncios de vagas em canais de comunicação e a possibilidade de realizar as entrevistas com candidatos de forma remota por vídeos ao vivo e/ou gravados.</p>
              <p
                class="block_2"
              >Estes Termos de Uso regulam a sua utilização no que se refere ao uso do site da Jovool e ao oferecimento da Plataforma de Recrutamento e Seleção, bem como do uso que o usuário fizer destas Plataformas de Serviços e Produtos. O termo “serviço”, quando utilizado, significa o serviço personalizado fornecido pela Jovool da plataforma de recrutamento e entrevistas por vídeo.</p>
              <p
                class="block_2"
              >O termo “Você” se refere à pessoa física ou à pessoa jurídica titular dos dados de login criados para acessar a Plataforma Jovool.</p>
              <p class="block_1">&nbsp;</p>
              <ol class="list_">
                <li class="block_3">
                  <b class="calibre2">ACEITAÇÃO DO CONTRATO</b>
                </li>
              </ol>
              <p
                class="block_2"
              >1.1. Ao clicar no botão “Eu li e concordo”, quando do cadastro online para uso da Plataforma da Jovool em nosso site, você automaticamente concordará com estes Termos de Uso.</p>
              <p
                class="block_2"
              >1.2. Se você não concordar com estes Termos e Uso, recomendamos que você não finalize o seu cadastro nem faça utilização de nosso site.</p>
              <p
                class="block_2"
              >1.3. Ao acessar e se cadastrar em nosso site e na plataforma, você declara ser civilmente capaz para compreender, aceitar e cumprir estes Termos de Uso.</p>
              <p class="block_2">
                1.4. Se você ficar com qualquer dúvida após ter lido estes Termos de Uso, por favor entre em contato conosco por meio do e-mail
                <a
                  href="mailto:contato@jovool.com"
                  class="text_"
                >contato@jovool.com</a>.
              </p>
              <p class="block_1">&nbsp;</p>
              <ol class="list_">
                <li value="2" class="block_3">
                  <b class="calibre2">CONDIÇÕES GERAIS</b>
                </li>
              </ol>
              <p class="block_2">
                2.1.
                <span class="tab">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>O acesso à Plataforma da Jovool será liberado após você preencher todos os dados cadastrais obrigatórios e fizer a escolha do plano a ser utilizado e o respectivo pagamento confirmado. Logo após, a Jovool criará e disponibilizará a você login para acesso à Plataforma.
              </p>
              <p
                class="block_2"
              >2.2. Você é o único responsável pela veracidade das informações que fornece, sendo que a Jovool não se responsabilizará por informações erradas e/ou falsas. Além disso, você deverá manter todas as suas informações atualizadas.</p>
              <p
                class="block_2"
              >2.3. Se a Jovool constatar que você forneceu alguma informação errada / falsa, seu cadastro poderá ser automaticamente cancelado.</p>
              <p
                class="block_2"
              >2.4. Você é exclusivamente responsável pela segurança de sua senha, e não deverá compartilhá-la com terceiros. Você é o único responsável por qualquer uso indevido em seu perfil, inclusive aqueles decorrentes de uso de sua senha por terceiros.</p>
              <p class="block_1">&nbsp;</p>
              <p class="block_2">
                2.5. Você está ciente de que o mero cadastro no site não acarretará acesso à plataforma oferecida pela Jovool
                <span
                  class="calibre1"
                >. O acesso só será autorizado após comprovação do pagamento, com exceção da utilização concedida em caráter de experimentação gratuito, que dá acesso à dois logins por CNPJ cadastrado.</span>
              </p>
              <p
                class="block_2"
              >2.6. Você pode exercer, no prazo de 7 dias a contar da disponibilização do acesso à plataforma, seu direito de arrependimento, nos termos do artigo 49 da Lei nº 8.098/90 (Código de Defesa do Consumidor). Você poderá requerer o cancelamento do acesso e a devolução dos valores pagos por meio do email contato@jovool.com ou ligar diretamente para a empresa através do telefone publicado no website.</p>
              <p class="block_1">&nbsp;</p>
              <ol class="list_">
                <li value="3" class="block_3">
                  <b class="calibre2">FINALIDADES DE USO DA PLATAFORMA</b>
                </li>
              </ol>
              <p class="block_4">Por meio do uso da Plataforma é possível:</p>
              <p
                class="block_4"
              >3.1. Criar e organizar um processo seletivo, por meio da metolodogia Kaban realizando a triagem de candidatos de acordo com o perfil buscado para cada processo seletivo.</p>
              <p
                class="block_4"
              >3.2 Fazer uso da ferramenta de vídeo com até 5 pessoas de forma simultânea.</p>
              <p class="block_4">3.3 Realizar entrevistas de forma programa ou real time por vídeo.</p>
              <p
                class="block_4"
              >3.4 Controlar as respostas dos candidatos com limite de tempo do vídeo e de tentativas de gravação.</p>
              <p
                class="block_4"
              >3.5 Utilizar o sistema de feedback automatizado para candidatos reprovados e o sistema de rankeamento de candidatos, bem como a gestão de indicadores de todas as etapas do processo.</p>
              <p
                class="block_4"
              >3.6 Compartilhar vídeos por e-mail com outras pessoas que não necessariamente possuem acesso à plataforma. Pelo período de até sete dias o link ficará ativo.</p>
              <p
                class="block_4"
              >3.7 Compartilhar vídeos institucionais e mensagens personalizadas apresentando sua marca ou criar processos confidenciais.</p>
              <p class="block_4">3.8 Divulgar vagas em diversos canais de comunicação.</p>
              <p class="block_5">&nbsp;</p>
              <ol class="list_">
                <li value="4" class="block_6">
                  <b class="calibre2">NORMAS DE CONDUTA E PROTEÇÃO À PROPRIEDADE INTELECTUAL</b>
                </li>
              </ol>
              <p
                class="block_2"
              >4.1. Você deverá cumprir a legislação do local onde estiver situado, bem como a legislação do Brasil.</p>
              <p
                class="block_2"
              >4.2. Você declara que não produzirá, reproduzirá, disponibilizará, divulgará ou transmitirá conteúdo:</p>
              <p
                class="block_2"
              >(i) contrário à legislação brasileira, ou que incentive qualquer forma de discriminação, racismo, homofobia e/ou violência;</p>
              <p
                class="block_2"
              >(ii) protegido por direitos de propriedade intelectual ou industrial de terceiros, sem que você esteja devidamente autorizado a usá-los pelos titulares destes direitos;</p>
              <p
                class="block_2"
              >(iii) sejam capazes de gerar danos ou impedir o normal funcionamento da rede, sistema ou equipamentos informáticos (hardware e software) da Jovool ou de terceiros, ou que possam danificar os arquivos armazenados virtualmente;</p>
              <p
                class="block_2"
              >(iv) causem dificuldades ao funcionamento normal do site da Jovool bem como de seus respectivos produtos e serviços.</p>
              <p
                class="block_2"
              >4.3. Você declara e reconhece que é o único responsável pelo uso que fizer da plataforma Jovool, bem como pelos atos que praticar enquanto estiver se utilizando dos serviços.</p>
              <p
                class="block_2"
              >4.4 Você está ciente de que há áreas restritas dentro do site da Jovool acessíveis apenas mediante login e senha especiais. Assim, ainda que por algum erro e/ou falha do sistema da Jovool você tiver acesso a estas áreas restritas, você deverá imediatamente encerrar o acesso, ficando civil e criminalmente responsável pelos danos que forem causados caso você não siga estas instruções.</p>
              <p
                class="block_2"
              >4.5. O conteúdo disponibilizado na Plataforma Jovool como logomarcas, vídeos, arquivos, textos, ícones, desenhos, layouts, sons, algoritmos (são de propriedade exclusiva da Jovool) ou de terceiros que autorizaram a Jovool a usá-los, estando protegidos pela lei. Nesse sentido, fica vedada sua cópia, reprodução ou qualquer tipo de utilização sem a autorização prévia e por escrita do titular deste direito.</p>
              <p
                class="block_2"
              >4.6. Ao usar a plataforma você concorda que não está autorizado a citar as marcas, os nomes comerciais e logotipos que lhe forem disponibilizados.</p>
              <p
                class="block_2"
              >4.7. Ao participar de qualquer entrevista, reunião e vídeos de forma geral online você autoriza a Jovool a utilizar sua imagem e sua voz em qualquer material que a Jovool vier a produzir, seja ele físico ou virtual.</p>
              <p
                class="block_2"
              >4.8. Todos os indivíduos &ndash; incluindo os candidatos &ndash; autorizam a Jovool a utilizarem sua imagem e voz durante a reprodução dos vídeos ao vivo e/ou gravados dentro da própria plataforma. Assim, você concorda que o uso indevido destes conteúdos atribuídos a sua má utilização constitui, além da violação dos direitos de propriedade intelectual da própria Jovool, a violação também dos direitos de imagem destes indivíduos. Você será responsável civil e penalmente pelos atos que praticar e vier a violar estes direitos.</p>
              <p
                class="block_4"
              >4.9 Não é de responsabilidade da Jovool a verificação da veracidade das informações divulgadas por você por meio dos anúncios de vagas, vídeos institucionais e quaisquer outras informações disponibilizadas dentro da plataforma ou por meio da plataforma.</p>
              <ol class="list_">
                <li value="5" class="block_7">
                  <b class="calibre3">CONDIÇÕES DE PAGAMENTO E CANCELAMENTO</b>
                </li>
              </ol>
              <p class="block_8">&nbsp;</p>
              <div class="calibre4">
                <div class="block_9">
                  <span class="bullet_">5.1.&nbsp;</span>
                  <span
                    class="calibre5"
                  >A Jovool disponibiliza planos de assinatura mensal com valores e condições de acesso diferenciados. Você deverá escolher o plano no momento do cadastro na Plataforma.</span>
                </div>
                <div class="block_9">
                  <span class="bullet_">5.2.&nbsp;</span>
                  <span
                    class="calibre5"
                  >É permitida a alteração a qualquer momento do plano, que deverá ser realizada por meio do site.</span>
                </div>
                <div class="block_9">
                  <span class="bullet_">5.3.&nbsp;</span>
                  <span
                    class="calibre5"
                  >Em caso de mudança do plano em que haja uma correção de valores, a cobrança do mês seguinte refletirá a diferença entre os valores dos planos, de modo proporcional ao tempo de uso do novo plano.</span>
                </div>
                <div class="block_9">
                  <span class="bullet_">5.4.&nbsp;</span>
                  <span
                    class="calibre5"
                  >Os planos serão renovados mês após mês automaticamente. Caso você queira encerrar a assinatura do plano, este processo deverá ser realizado diretamente pelo site.</span>
                </div>
                <div class="block_9">
                  <span class="bullet_">5.5.&nbsp;</span>
                  <span
                    class="calibre5"
                  >Com a renovação automática mensalmente, caso você tenha optado pela forma de pagamento via cartão de crédito, o valor da mensalidade será cobrado automaticamente em sua próxima fatura. Caso você tenha optado pela forma de pagamento via boleto bancário, será gerado um novo boleto automaticamente que ficará disponível para acesso na plataforma e caso o pagamento não ocorra até a data de vencimento do boleto, o acesso à plataforma será automaticamente bloqueado até que o pagamento seja efetuado.</span>
                </div>
                <div class="block_9">
                  <span class="bullet_">5.6.&nbsp;</span>
                  <span class="calibre5">
                    Em hipótese alguma, a Jovool
                    <span
                      class="calibre6"
                    >devolverá o valor investido referente ao mês vigente da assinatura, caso o cancelamento seja feito com mais de sete dias a contar da data do cadastro inicial.</span>
                  </span>
                </div>
                <div class="block_9">
                  <span class="bullet_">5.7.&nbsp;</span>
                  <span
                    class="calibre5"
                  >Somente não serão aplicados os itens de 5.4 a 5.6 ao modelo de assinatura gratuito, disponível para experimentação de novos clientes pelo prazo de um mês, a contar da data de liberação de acesso. Ao final deste prazo, a assinatura será automaticamente encerrada e os acessos bloqueados.</span>
                </div>
              </div>
              <p class="block_10">&nbsp;</p>
              <ol class="list_">
                <li value="6" class="block_6">
                  <b class="calibre2">ABUSOS E IRREGULARIDADES</b>
                </li>
              </ol>
              <p
                class="block_2"
              >6.1. Você deverá comunicar à Jovool caso identifique conteúdos ofensivos ou ilegais que sejam transmitidos por outros usuários, tais como candidatos que estejam participando das etapas do processo seletivo dentro da Plataforma. Esta denúncia será sempre anônima, e quando feita online, será realizada por meio do email contato@jovool.com.</p>
              <p
                class="block_2"
              >6.2. A Jovool possui total autonomia e independência para decidir se apurará ou não as denúncias que lhe forem encaminhadas.</p>
              <p
                class="block_2"
              >6.3. Usuários que se comportarem de modo irregular, abusivos e/ou ilícito poderão ter seu acesso suspenso e/ou cancelado na Plataforma.</p>
              <p
                class="block_2"
              >6.4. Você indenizará a Jovool por qualquer dano que causar à Jovool e/ou a terceiros em decorrência do descumprimento de qualquer disposição destes Termos de Uso.</p>
              <p class="block_1">&nbsp;</p>
              <ol class="list_">
                <li value="7" class="block_3">
                  <b class="calibre2">FIM DO ACESSO À PLATAFORMA JOVOOL</b>
                </li>
              </ol>
              <p class="block_2">
                7.1. A Jovool pode, a qualquer momento, encerrar, suspender ou interromper seu acesso à Plataforma caso você viole a legislação ou descumpra qualquer disposição destes Termos de Uso ou de qualquer outro instrumento da Jovool
                <span
                  class="calibre1"
                >ao qual você esteja vinculado.</span>
              </p>
              <p
                class="block_2"
              >7.2. Ressalvada a hipótese prevista no item 5.1 acima, você terá acesso à Plataforma enquanto perdurar o contrato vigente que você tiver adquirido e comprovadamente pago.</p>
              <p class="block_1">&nbsp;</p>
              <ol class="list_">
                <li value="8" class="block_3">
                  <b class="calibre2">EXCLUSÃO DE GARANTIAS E RESPONSABILIDADES</b>
                </li>
              </ol>
              <p
                class="block_2"
              >8.1. Você concorda que a Jovool não é responsável por danos decorrentes do mau funcionamento de seu site e da Plataforma e pela interrupção de seu acesso.</p>
              <p
                class="block_2"
              >8.2. A Jovool se utiliza das melhores práticas de mercado para manter seguras as informações que você disponibiliza na Plataforma. A Jovool não é responsável, no entanto, por danos e prejuízos de qualquer natureza decorrentes do conhecimento que terceiros não autorizados tenham sobre suas informações, por falha atribuível a você ou a terceiros e que fujam do controle razoável da Jovool.</p>
              <p
                class="block_2"
              >8.3. A Jovool poderá realizar a qualquer momento todas as alterações em seu site e na Plataforma que julgar necessárias, sem precisar avisá-lo com antecedência.</p>
              <p class="block_2">
                8.4. A Jovool apenas será obrigada a pagar a você indenizações pelos danos diretos que a Jovool tiver comprovadamente causado a você, sempre limitado ao montante total que você tiver pago à Jovool
                <span
                  class="calibre1"
                >.</span>
              </p>
              <p
                class="block_2"
              >8.5 Fica certo e acordado que Jovool e você possuem conhecimento e cumprirão as disposições da LGPD, 13.709/2018, a Lei Geral de Proteção de Dados&nbsp;(“LGPD”), que dispõe sobre a proteção de dados pessoais no Brasil, que devem ser cumpridas durante toda a vigência deste Contrato. As Partes comprometem-se a tratar (coletar, processar, compartilhar e utilizar) assegurando a confidencialidade das informações e que sejam obtidos conforme os arts. 7 e 11 da&nbsp;LGPD.</p>
              <p class="block_1">&nbsp;</p>
              <ol class="list_">
                <li value="9" class="block_3">
                  <b class="calibre2">PRAZO DE VIGÊNCIA E TÉRMINO DO CONTRATO</b>
                </li>
              </ol>
              <p
                class="block_2"
              >9.1 Este Termo de Uso tem validade de um ano e será renovado automaticamente após este período podendo ser encerrado a qualquer momento pela Jovool ou por você.</p>
              <p class="block_2">
                9.2
                <span
                  class="calibre1"
                >No encerramento deste Termo de Uso, por quaisquer que sejam as razões, você não terá mais acesso à Plataforma, incluindo todo e qualquer conteúdo lá disposto tais como entrevistas realizadas pela ferramenta de vídeo, informações dos candidatos, status do processo seletivo entre outros.</span>
              </p>
              <p class="block_1">&nbsp;</p>
              <ol class="list_">
                <li value="10" class="block_3">
                  <b class="calibre2">DIVERSOS</b>
                </li>
              </ol>
              <p
                class="block_2"
              >10.1. Lei Aplicável. Estes Termos de Uso serão regidos e interpretados de acordo com lei brasileira.</p>
              <p
                class="block_2"
              >10.2. Atendimento, Dúvidas e Conflitos. Para obter mais informações sobre a Plataforma ou caso precise de ajuda com seu acesso à Plataforma, por favor, acesse o e-mail de contato em nosso site. Se houver conflitos entre estes Termos de Uso e as informações transmitidas durante o atendimento, estes Termos de Uso prevalecerão.</p>
              <p
                class="block_2"
              >10.3. Invalidade, Ilegalidade e Inaplicabilidade. Se qualquer disposição destes Termos de Uso for considerada inválida, ilegal ou inaplicável, isso não afetará as demais disposições, que permanecerão válidas, legais e aplicáveis.</p>
              <p
                class="block_2"
              >10.4. Alteração dos Termos de Uso e Cessão. A Jovool pode alterar estes Termos de Uso a qualquer tempo. Neste caso, você será notificado em até 30 dias antes que as alterações se apliquem a você. A qualquer momento, a Jovool pode ceder ou transferir o contrato que eventualmente mantiver com você, inclusive os direitos e obrigações a ele associados.</p>
              <p
                class="block_2"
              >10.5. Resolução de Conflitos. O foro para resolver eventuais disputas referentes a estes Termos de Uso será o central da capital de São Paulo - SP.</p>
              <p class="block_1">&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AdminCandidate>
</template>

<script>
import AdminCandidate from "layouts/AdminCandidate.vue";
export default {
  components: { AdminCandidate },
};
</script>

<style>
</style>